import { gql } from "@apollo/client";

export const InstalledBaseNodeTypeList = gql`
    query InstalledBaseNodeTypeList(
        $industryType: IndustryType
        $parentInstalledBaseNodeTypeKey: InstalledBaseNodeTypeKey!
    ) {
        installedBaseNodeTypeList(filter: { industryType: { equals: $industryType } }) {
            total
            installedBaseNodeTypes {
                id
                key
                name
                category
                description
                recommended(parentInstalledBaseNodeTypeKey: $parentInstalledBaseNodeTypeKey)
            }
        }
    }
`;
